export * from './permisos-detail.component';
export * from './action';



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/abm/permisos-detail/index.ts